// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"fb7e04d0","156":"238340fc","182":"6aafa60d","228":"25a34579","366":"8c914ced","616":"0024f66a","712":"23b060b9","766":"e7f741c9","838":"2af9bacc"}[chunkId] + ".chunk.css";
};